import axios from "axios";
import { axiosApi } from "../axios";
import { markAsReadPayload } from "../types/following";

// MarkAsRead only accepts a `messages` shape — it patches each id directly as a
// message ID and does not resolve conversations/items down to message IDs.
export const markAsReadRequest = async (userId: string, itemIds: string[]): Promise<{ success: boolean }> => {
  const payload: markAsReadPayload = {
    messages: itemIds.map((id) => ({ id })),
  };
  try {
    // Response body is always empty (server returns Ok() with no payload).
    // A 200 only means the batch request was accepted, not that every
    // message was actually marked read server-side — failures are logged
    // server-side only and not surfaced here.
    await axiosApi.post(`/users/${userId}/markAsRead`, payload);
    return { success: true };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`Failed to mark messages as read: ${error.response?.status} ${error.response?.statusText}`);
    }
    throw new Error("An unexpected error occurred while marking messages as read.");
  }
};
